import React, {Component} from 'react';
import DatePicker from "react-datepicker";
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import LoginDom from './login';

// class 页面的其他
class OtherInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {...this.props};
    this.state.isRight = false;
    if (this.state.questions && this.state.questions.length > 0) {
      this.state.questions.forEach(valQ => {
        if (this.state.answers && this.state.answers.length > 0 ) {
          this.state.answers.forEach(valA => {
            if(valQ.id === valA.question) {
              valQ.content = valA.content;
            }
          })
        } else {
          if (valQ.q_type === 2 ) { // 0 文本，1 单选， 2 多选
            valQ.content = []
          } else {
            valQ.content = ''
          }
        }
        valQ.question = valQ.id;
      })

      console.log("question >> " + JSON.stringify(this.state.questions))
      console.log("answers >> " + JSON.stringify(this.state.answers))
      console.log("state >> " + JSON.stringify(this.state))
    }
  }
  handleChange = (e) => {
    const [value, id] = [e.target.value, e.target.id];
    const changeArr = this.state.questions;
    if (changeArr && changeArr.length > 0){ 
      changeArr.forEach(val => {
        if (id+'' === val.id+'') {
          val.content = value;
        }
        val.question = val.id;
      });
    }
    this.setState({
      questions: changeArr
    }, () => {
      this.state.isRight = this.validateFunction();
      this.props.receiveData({ answers: this.state.questions, isRight: this.state.isRight })
    })
  }
  handleSingleSelect = (e) => {
    const [value, id] = [e.target.value, e.target.id];
    const changeArr = this.state.questions;
    if (changeArr && changeArr.length > 0){ 
      changeArr.forEach(val => {
        if (id+'' === val.id+'') {
          val.content = value;
        }
        // val.question = val.id;
      });
    }

    this.setState({
      questions: changeArr
    }, () => {
      this.state.isRight = this.validateFunction();
      this.props.receiveData({ answers: this.state.questions, isRight: this.state.isRight })
    })
  }
  handleMultiSelectFake = (e) => { }
  handleMultiSelect = (e) => {
    const [value, id] = [e.target.value, e.target.id];
    const changeArr = this.state.questions;

    if (changeArr && changeArr.length > 0){ 
      changeArr.forEach(val => {
        if (id+'' === val.id+'') {
          if (typeof val.content === 'string') {
            val.content = []
          }

          if (!Array.isArray(val.content)) {
            val.content = []
          }

          var index = val.content.indexOf(value)

          if (index == -1) {
            val.content.push(value)
          } else {
            val.content.splice(index, 1)
          }
        }
      });
    }

    this.setState({
      questions: changeArr
    }, () => {
      this.state.isRight = this.validateFunction();
      this.props.receiveData({ answers: this.state.questions, isRight: this.state.isRight })
    })
  }
  validateFunction = () => {
    const qs = this.state.questions;
    if (qs && qs.length > 0) {
      for (var i = 0; i < qs.length; i++) {
        var q = qs[i]
        if (q.required) {
          if (!!!q.content || q.content == "" || q.content.length === 0) {
            return false
          }
        }
      }
    }
    return true;
  }
  componentDidMount () {
    this.state.isRight = this.validateFunction();
    this.props.receiveData({ answers: this.state.questions, isRight: this.state.isRight })
    // this.props.receiveData({ answers: this.state.questions , })
  }
  render () {
    return (
      <div className="other-info padding-top-30 border-top">
        <p className="s-title">其他信息</p>
        { 
          this.state.questions.map(val => {
            const showErr = this.props.checkErr &&  val.content.length == 0;
            return (
              <div className="info-item" key={val.id}>
                {/* <p className="p-title">{JSON.stringify(val)}</p> */}
                <p className="p-title">
                  {val.required && <span className="color-red"> * </span> }
                  {val.name}
                  {/* { val.q_type == 1 && <span> 单选 </span> } */}
                  {/* { val.q_type == 2 && <span> 多选 </span> } */}
                  { !val.required && <span className="color-gray"> 选填 </span> }
                  {  showErr && val.required && <span className="color-red"> 必填 </span> }
                </p>
                { val.q_type == 0 && <textarea className="l-textarea" id={val.id} onChange={this.handleChange} value={val.content}  placeholder={val.holder}/> }
                { val.q_type == 1 && 
                  val.options.map( op => {
                    return ( 
                      <div className="margin-bottom-10 margin-left-5 question-option" key={op}>
                        <label className="s-radio">
                          <input className="question-checkbox" type="radio" value={op} checked={val.content === op ? true : false} onChange={this.handleSingleSelect}  id={val.id}/>
                          <span className="span-radio question-label">{op}</span>
                        </label>
                      </div>
                    )
                  })
                }
                { val.q_type == 2 && 
                  val.options.map( op => {
                    return ( 
                      <div className="margin-bottom-10 margin-left-5 question-option" key={op}>
                        <label className="s-radio">
                          <input className="question-checkbox" type="checkbox" value={op} checked={val && val.content && val.content.indexOf(op) > -1 ? true : false} onClick={this.handleMultiSelect} onChange={this.handleMultiSelectFake}  id={val.id}/>
                          <span className="span-radio question-label">{op}</span>
                        </label>
                      </div>
                    )
                  })
                }
              </div>
            )
          })
        }
      </div>
    )
  }
}

// 主题游学
class ExpoNeedsInfo extends Component {
  static defaultProps = {
    is_plane_ticket: true,
    is_visa: true,
    is_single_fee: false
  }
  constructor(props) {
    super(props);
    this.state = { ...props };
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.setState({
      [key]: value
    }, () => {
      this.props.receiveData({...this.state});
    })
  }
  componentDidMount() {
    this.props.receiveData({...this.state});
  }
  render() {
    return (
      <div className="expo-other-info">
        <p>您是否需要小饭桌创业课堂代办机票、签证？此时只是了解意向，最终的办理前还会与您再次确认。</p>
        <div className="info-item">
          <label className="s-label">需代购机票</label>
          <select className={"s-select"} name="is_plane_ticket" value={this.state.is_plane_ticket} onChange={this.handleChange}>
            <option value="">请选择</option>
            <option value="true">需要</option>
            <option value="false">不需要</option>
          </select>
        </div>
        <div className="info-item">
          <label className="s-label">需代办签证</label>
          <select className={"s-select"} name="is_visa" value={this.state.is_visa} onChange={this.handleChange}>
            <option value="">请选择</option>
            <option value="true">需要</option>
            <option value="false">不需要</option>
          </select>
        </div>
        <div className="info-item">
          <label className="s-label">住宿要求</label>
          <select className={"s-select"} name="is_single_fee" value={this.state.is_single_fee} onChange={this.handleChange}>
            <option value="">请选择</option>
            <option value="true">需要单间</option>
            <option value="false">服从分配</option>
          </select>
        </div>

        <div className="info-item">
          <label className="s-label">其他要求</label>
          <textarea
            className="s-textarea"
            name="other"
            value={this.state.other}
            onChange={this.handleChange}
          />
        </div>
      </div>
    )
  }
}


// 游学定制
class ExpoComNeedsInfo extends Component {
  static defaultProps = {
    hope_travel_time: ''
  }
  constructor(props) {
    super(props);
    this.state = { ...props };
    this.isRight = true;
  }
  addMonths = (nowDate, addMonth) => {
    nowDate.setMonth(nowDate.getMonth() + addMonth);
    return nowDate;
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.setState({
      [key]: value
    }, () => {
      if (this.state.hope_travel_time) {
        this.state.hope_travel_time = moment(this.state.hope_travel_time).format('YYYY-MM-DD');
      }
      this.state.isRight = this.validateFunction();
      this.props.receiveData({...this.state});
    })
  }
  handleChangeTime = (date) => {
    const chooseDate =  date ? moment(date).format('YYYY-MM-DD') : '';
    this.setState({
      hope_travel_time: chooseDate
    }, () => {
      this.state.isRight = this.validateFunction();
      this.props.receiveData({...this.state});
    });
  }
  validateFunction = () => {
    let flag = true;
    const validateMap = new Map();
    let projectVliArr = ['theme', 'country', 'hope_travel_time', 'companion_count'];
    
    validateMap.set('expoValidate', projectVliArr);
    for (let i in this.state) {
      if (validateMap.get('expoValidate').indexOf(i) > -1 && !this.state[i]) {
        flag = false;
        break;
      }
    }
    return flag;
  }
  componentDidMount() {
    this.state.isRight = this.validateFunction();
    if (this.state.hope_travel_time) {
      this.state.hope_travel_time = moment(this.state.hope_travel_time).format('YYYY-MM-DD')
    }
    this.props.receiveData({...this.state});
  }
  render() {
    const showErrCountry = this.props.checkErr && !!!this.state.country;
    const errCountry = showErrCountry ? 'err-s' : '';
    const classCountryName = `s-select ${errCountry}`;

    const showErrTheme= this.props.checkErr && !!!this.state.theme;
    const errTheme = showErrTheme ? 'err-s' : '';
    const classThemeName = `s-select ${errTheme}`;

    const showErrTime = this.props.checkErr && !!!this.state.hope_travel_time;
    const errTime = showErrTime ? 'err-s' : '';
    const classTimeName = `s-select ${errTime}`;

    const showErrPeer = this.props.checkErr && !!!this.state.companion_count;
    const errPeer = showErrPeer ? 'err-s' : '';
    const classPeerName = `s-input ${errPeer}`;

    const ThemeArr =  ['消费零售', '文创IP', '房产', '家居', '本地生活', '消费金融', '品牌', 'Fintech', '数字币', 'ico', '人工智能', '企业服务', '电影产业', '特效科技', '新技术', '新医疗医药'];
    const countryArr = ['日本', '美国', '瑞士', '印度', '以色列'];


    return (
      <div className="expo-other-info">
        <div className="info-item">
          <label className="s-label">感兴趣的主题</label>
          <select className={classThemeName} name="theme" value={this.state.theme} onChange={this.handleChange}>
            <option value="">请选择</option>
            {
              ThemeArr.map(val => {
                return <option value={val} key={val}>{val}</option>
              })
            }
          </select>
          { showErrTheme && <span className="err-tips">请选择感兴趣的主题</span> }
        </div>
        <div className="info-item">
          <label className="s-label">感兴趣的国家</label>
          <select className={classCountryName} name="country" value={this.state.country} onChange={this.handleChange}>
            <option value="">请选择</option>
            {
              countryArr.map(val => {
                return <option value={val} key={val}>{val}</option>
              })
            }
          </select>
          { showErrCountry && <span className="err-tips">请选择感兴趣的国家</span> }
        </div>

        <div className="info-item">
          <label className="s-label">希望出行时间</label>
          <DatePicker
            className = {classTimeName}
            customInput={<ExampleCustomInput checkErr={this.props.checkErr}/>}
            selected={this.state.hope_travel_time ? new Date(this.state.hope_travel_time) : null}
            onChange={this.handleChangeTime}
            minDate={ new Date() }
            maxDate={ this.addMonths(new Date(), 3)}
          />
          { showErrTime && <span className="err-tips">请选择希望出行时间</span> }
        </div>

        <div className="info-item">
          <label className="s-label">同行人数</label>
          <input
            type="number"
            className={classPeerName}
            name="companion_count"
            value={this.state.companion_count}
            onChange={this.handleChange}
          />
          { showErrPeer && <span className="err-tips">请填写同行人数</span> }
        </div>
      </div>
    )
  }
}

class ExampleCustomInput extends Component {
  render () {
    return (
      <button
        className={
          this.props.checkErr && !!!this.props.value ? "s-select choose-time err-s" : "s-select choose-time" 
        }
        onClick={this.props.onClick}>
        {this.props.value}
      </button>
    )
  }
}


// 票种 市场活动
class PickTickets extends Component {
  constructor(props) {
    super(props);
    this.state = {...props};
    if (this.state.tickets && this.state.tickets.length > 0) {
      this.state.tickets.forEach((val, index) => {
        if(index === 0) {
          this.chooseProduct = val;
          val.selected = true;
        }
      })
    }
    this.props.receiveData({
      ...this.chooseProduct
    })
  }
  chooseTicket = (event) => {
    const selectNum = event.currentTarget.getAttribute('data-index');
    event.preventDefault();
    this.state.tickets.map((val, index) => {
      if(index+'' === selectNum) {
        this.chooseProduct = val;
        val.selected = true;
      } else {
        val.selected = false
      }
    })
    this.setState({
      tickets: this.state.tickets
    })
    this.props.receiveData({
      ...this.chooseProduct
    })
  }
  render() {
    if (this.state.tickets && this.state.tickets.length > 0) {
      return (
        <div className="tickets-wrapper border-bottom margin-bottom-30">
          <p className="s-title">选择票种</p>
          <div className="ticket-content">
            {
              this.state.tickets && this.state.tickets.length > 0 && this.state.tickets.map((val, index) => {
                return (
                  <div 
                    className={ val.selected ? 'each-ticket selected' : 'each-ticket' } 
                    key={ val.product_id.toString() } 
                    onClick={ this.chooseTicket }
                    data-index={ index }>
                      {/* { val.photo && <img src={val.photo} className="ticket-img"/> } */}
                      <div className="text-detail">
                        <p className="ticket-name">{val.name}</p>
                        <p className="ticket-fee">¥{val.fee}</p>
                        <p className="ticket-intro">{val.intro}</p>
                      </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      )
    } else {
      return null;
    }
  }
}

export {
  OtherInfo,
  ExpoNeedsInfo,
  ExpoComNeedsInfo,
  PickTickets
}